
  import {Vue, Component, Prop} from "vue-property-decorator";
  import FormInput from "@/components/form/FormInputNew.vue";
  import debounce from "lodash-es/debounce";
  @Component({
    components: {
      FormInput,
    },
  })
  export default class InputFilter extends Vue {
    @Prop({type: String, default: undefined}) value!: string;
    @Prop({type: String, default: undefined}) placeholder!: string;
    @Prop({type: Number, default: 500}) debounceTime!: number;
   
    handleInput = debounce((value: string) => {
      this.$emit("input", value);
    }, this.debounceTime);
  }
